import {
  AddShoppingCart,
  CallRounded,
  FactCheckOutlined,
  ShoppingCartRounded,
  Store,
} from '@mui/icons-material'
import classNames from 'classnames'
import { ScreenEnum, useScreen } from 'feature/screenMode'

import { MenuCollapse } from '../menuCollapse/MenuCollapse'

import { UserTypeSelectionModal } from 'widget/UserTypeSelectionModal/UserTypeSelectionModal'

import { ConsultationModal } from './ConsultationModal'
import { useOrderBlock } from './hooks/useOrderBlock'
import style from './OrderBlock.module.scss'
import { ProductConsultationModal } from './ProductConsultationModal'

type OrderBlockProps = {
  isUserExist: boolean
}

//раздел "готовы сделать заказ?"

export function OrderBlock({ isUserExist }: OrderBlockProps) {
  const screen = useScreen()

  const {
    handleCloseConsultModal,
    handleCloseProductConsultModal,
    handleOpenConsultModal,
    isOpenConsultModal,
    isOpenProductConsultModal,
    isActiveAppealsExist,
    isOpenOrderTypeModal,
    handleOrderClick,
    handleOrderTypeSelect,
    handleCloseOrderTypeModal,
  } = useOrderBlock()

  return (
    <section
      className={classNames(
        'pt24 pb24',
        style.menuWrap,
        classNames({ [style.menuWrap_authenticated]: isUserExist }),
      )}
    >
      <span
        className={classNames('h1 mobile-hidden', {
          'desktop-hidden': !isUserExist,
        })}
      >
        Готовы сделать заказ?
      </span>
      <div
        className={classNames(style.box, {
          [style.box_row]: isUserExist && screen === ScreenEnum.tablet,
        })}
      >
        <MenuCollapse
          className={style.menuCollapse}
          Icon={ShoppingCartRounded}
          text='Заказы'
          defaultOpen
          toggleTestId='orders-collapse-toggle'
          items={[
            {
              Icon: AddShoppingCart,
              text: 'Покупка с завода',
              handleClick: handleOrderClick,
              testId: 'order-menu-product-order',
            },
            {
              Icon: FactCheckOutlined,
              text: 'Мои заказы',
              link: '/appeals',
              hidden: !isActiveAppealsExist,
              testId: 'order-menu-appeals',
            },
            {
              Icon: CallRounded,
              text: 'Консультация перед покупкой',
              link: '/',
              handleClick: handleOpenConsultModal,
              testId: 'order-menu-consultation',
            },
            {
              Icon: Store,
              text: 'Интернет-магазин',
              link: 'https://doorhanstore.ru/',
              blank: true,
              testId: 'order-menu-store',
            },
          ]}
        />
      </div>

      <UserTypeSelectionModal
        open={isOpenOrderTypeModal}
        onClose={handleCloseOrderTypeModal}
        onSelect={handleOrderTypeSelect}
      />

      <ConsultationModal
        isOpen={isOpenConsultModal}
        onClose={handleCloseConsultModal}
      />

      <ProductConsultationModal
        isOpen={isOpenProductConsultModal}
        onClose={handleCloseProductConsultModal}
      />
    </section>
  )
}
